//const { forEach } = require("lodash");

angular.module('inspecciones')
    .controller('inspeccionesPresaController', ['$scope', '$rootScope', '$routeParams', '$location', 'inspeccionesService', 'infraestructurasService', 'authenticationInfo', 'authenticationService',
        function ($scope, $rootScope, $routeParams, $location, inspeccionesService, infraestructurasService, authenticationInfo, authenticationService) {


        $scope.authentication = authenticationInfo;
        $scope.InfraestructuraId = $routeParams.id;


            infraestructurasService.getPresa($scope.infraestructura.Id)
                .then(function (response) {
                    var data = response.data;
                    $scope.presa = data;


                    // Registrar el plugin
                    //Chart.register(ChartDataLabels);

                    infraestructurasService.getInspeccionesPresa($scope.presa.Id)
                        .then(function (response) {
                            var data = response.data;
                            $scope.inspecciones = data;
                            $scope.ultimainspeccion = new Object();
                            $scope.ultimainspeccion.Id = $scope.inspecciones[0].Id;
                            $scope.ultimainspeccion.fechafin = $scope.inspecciones[0].FechaFin;
                            $scope.ultimainspeccion.fechaInicio = $scope.inspecciones[0].FechaInicio;

                            $scope.ultimainspeccion.InspectorDescripcion = $scope.inspecciones[0].Inspector.Descripcion;
                            $scope.ultimainspeccion.InspectorId = $scope.inspecciones[0].Inspector.Id;

                            $scope.ultimainspeccion.PropietarioDescripcion = $scope.inspecciones[0].Propietario.Descripcion;
                            $scope.ultimainspeccion.PropietarioId = $scope.inspecciones[0].Propietario.Id;


                        });

                });

        $scope.crearInspeccion = function () {
            inspeccionesService.crearInspeccionPresa($scope.InfraestructuraId)
                .then(function (response) {
                    var data = response.data;
                    $scope.inspeccionId = data;
                    $location.url('/inspecciones/' + $routeParams.id + "/" + $scope.inspeccionId);
                });
        };

        $scope.verCategorias = function () {
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
            $location.path('/categorias');
        };
        //$scope.verInspeccion = function (idInspeccion) {
        //    $location.url('/inspecciones/' + $routeParams.id + "/" + idInspeccion);
        //}

        $scope.volver = function () {
            $rootScope.inspeccionUrl == false;
            $rootScope.parteUrl == false;
            $location.path('/categorias');
        };


        $scope.eliminarInspeccion = function (idInspeccion) {
            check = confirm("¿Seguro que deseas eliminar esta inspección?")

            if (check) {
                inspeccionesService.eliminarInspeccionPresa(idInspeccion)
                    .then(function (response) {
                        inspeccionesService.getInspeccionesPresa($scope.presa.Id)
                            .then(function (response) {
                                var data = response.data;
                                $scope.inspecciones = data;
                            });
                    });
            }
        }
    }]);

